// extracted by mini-css-extract-plugin
export var dividerLine = "_5k-3";
export var itemImage = "_5k-9";
export var lightDivider = "_5k-4";
export var modalContent = "_5k-5";
export var modalContentCompact = "_5k-6";
export var productCard = "_5k-a";
export var productImage = "_5k-b";
export var productImageCompact = "_5k-7";
export var productImagePlaceholder = "_5k-c";
export var productImagePlaceholderCompact = "_5k-8";
export var progressBarBackground = "_5k-1";
export var progressBarContainer = "_5k-0";
export var progressBarFill = "_5k-2";